import React from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { getRequest, showMessage } from '../../../config'
import moment from 'moment'
import { BILLING } from '../../../constants/routes'
import { useSelector } from 'react-redux'
import { packages } from '../../../env'

const Title = ({ lable }) => {
    return (<span className='c14 fw400 fs14px mr0-5rem'>{lable}</span>)
}

const Subscription = ({ isExpansion, lable, sub, companyId }) => {
    return (
        <div>
            <span className='c14 fw400 fs14px mr0-5rem'>{lable} : </span>
            <span className='ttu fw400 fs14px c59'>{sub}</span>
            {!isExpansion && (!sub || sub.toLowerCase() === "free") ? <Link to={`/billing/${companyId}`}>
                <span className='px1rem bg4 c1 py0-5rem fs12px br50px cp ml0-5rem'>Upgrade</span>
            </Link> : null}
        </div>
    )
}

const BillingCard = ({ company, idx }) => {
    const user = useSelector((state) => state.user);
    const navigate = useNavigate();
    const handleStripeInvoiceDownload = async (invoiceId, type) => {
        const response = await getRequest(`/payment/invoice-download/${invoiceId}?type=${type}`, 'not-showMessage');
        if (response && response.code === 200 && response.body?.url) {
            try {
                const link = document.createElement('a');
                link.href = response.body.url;
                link.target = '_blank';
                link.rel = 'noopener noreferrer';
                link.download = `invoice-${invoiceId}.pdf`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

            } catch (err) {
                console.error('Invoice download error:', err);
                showMessage("Failed to download invoice PDF");
            }
        } else {
            showMessage(response.message || "Failed to fetch invoice");
        }
    }

    return (
        <div key={idx} className="w100 py2rem px1rem br20px bg1 fs1-25rem my0-5rem billingCard">
            <div className='df aifs'>
                <div style={{ maxWidth: "42px" }} className='mr1rem'>
                    <img src={company["logo"] || require('../../../../images/yourlogohere.png')} alt="companyLogo" className="w100 cp br10px" />
                </div>
                <div className='w100'>
                    <div>
                        <div
                            className='cp'
                            onClick={() => {
                                if (company && company?.['subscription'] && company?.['subscription'].toLowerCase() === "pro" && user && ['investor', 'advisor'].includes(user?.['role']?.toLowerCase())) {
                                    return showMessage(`${company['cName']} have already on Pro Plan`);
                                }
                                navigate((company?.['creator']?.['createdBy']?.['role'] && user && ['investor', 'advisor'].includes(company?.['creator']?.['createdBy']?.['role']?.toLowerCase() || user?.['role']?.toLowerCase())) ? `${BILLING.replace(":id", company['_id'])}/pro/${company?.['creator']?.['createdBy']?.['role'].toLowerCase()}` : BILLING.replace(":id", company['_id']))
                            }}>
                            <h4 className='w100 c15 fw500'>{company['cName']}</h4>
                        </div>
                        <div style={{ lineHeight: 1 }}>
                            <Title lable={'Account Owner:'} />
                            <Title lable={`${company['creator']['firstName']} ${company['creator']['lastName']}`} />
                        </div>
                    </div>
                    <div className='mt1rem w100'>
                        <div className='billingTable'>
                            <Title lable={'Purchased'} />
                            <Title lable={'Status'} />
                            <Title lable={'Date'} />
                            <Title lable={'Renewal'} />
                            <Title lable={'Who'} />
                            <Title lable={'Billing'} />
                        </div>
                        <div className={'mt1rem'}>
                            {
                                company['payments'] && company['payments'].length > 0 ? <div className={'billingTable mt1rem'}>{
                                    company['payments'].map((payment, idx) => {
                                        const isExpansion = payment.purpose.startsWith('ExpensionPack-');
                                        let sub = isExpansion ? `${payment.purpose.split('=')[0].split('-')[1]} - ${payment.purpose.split('=')[1]}` : payment.purpose;
                                        if (sub.includes("undefined")) {
                                            let subId = sub.split('-')[0].trim();
                                            if (packages[subId]['name']) {
                                                sub = `${subId} - ${packages[subId]['name']}`
                                            } else {
                                                sub = "Unknown Product"
                                            }
                                        }

                                        const formattedDate = payment['nextPaymentDate'] ? moment.unix(payment['nextPaymentDate']).format('DD/MM/YYYY') : "-";
                                        const createdAt = moment(payment['createdAt']).format('DD/MM/YYYY') ?? "-";

                                        return (
                                            <React.Fragment key={`${payment['_id']}-${idx}`}>
                                                <Subscription
                                                    isExpansion={isExpansion}
                                                    lable={isExpansion ? 'Module' : 'Subscription'}
                                                    sub={sub}
                                                    companyId={company['_id']}
                                                />
                                                <Title lable={payment?.status} />
                                                <span className='c14 fw400 fs14px mr0-5rem'>{createdAt}</span>
                                                <Title lable={formattedDate} />
                                                {payment['user'] ?
                                                    payment['user']['profile']
                                                        ? <img
                                                            src={payment['user']['profile']}
                                                            className={`w40px h40px df jcc aic br100 cp bo30 bss bw3px client-profile`}
                                                            data-tooltip={payment['user']['firstName'] ? (payment['user']['firstName'] + " " + (payment['user']['lastName'] ?? "")) : "Register to show your name here"}
                                                        />
                                                        : <span className={`w40px h40px df jcc aic br100 bg3 c1 bw3px bss bo30 fs1rem c1 client-profile`} data-tooltip={payment['user']['firstName'] ? (payment['user']['firstName'] + " " + (payment['user']['lastName'] ? payment['user']['lastName'] : "")) : "Register to show your name here"}>{payment['user']['firstName'] ? (payment['user']['firstName'][0] + (payment['user']['lastName'] ? payment['user']['lastName']?.[0] : "")) : "?"}</span> : '-'
                                                }

                                                {payment['invoiceId'] ? <div onClick={() => handleStripeInvoiceDownload(payment['invoiceId'], 'subscription')} className='c3 cp fs1rem'>[Invoice]</div> : payment['paymentIntent'] ? <div onClick={() => handleStripeInvoiceDownload(payment['paymentIntent'], 'feature')} className='c3 cp fs1rem'>[Invoice]</div> : <div className='pl1rem'>-</div>}
                                            </React.Fragment>
                                        )
                                    })}</div> : <div className='w100 tac py2rem'>
                                    <h2 className='c15 fs1-5rem'>No Payments</h2>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>

        </div >

    )
}

export default BillingCard